if (!customElements.get('language-switcher')) {
  class LanguageSwitcher extends HTMLElement {
    constructor() {
      super();
      this.countrySelect = this.querySelector('[data-country-select]');
      this.languageSelect = this.querySelector('[data-language-select]');
      this.countryFlags = this.querySelectorAll('[data-country-flag]');
      this.currentCountryCode = this.dataset.currentCountryCode;
      this.currentLanguageCode = this.dataset.currentLanguageCode;

      if (!this.countrySelect || !this.languageSelect) return;

      this.countrySelect.addEventListener('change', this.onCountryChange.bind(this));

      const initialOption = this.countrySelect.selectedOptions[0];
      if (!initialOption) return;

      const languages = this._parseLanguages(initialOption.dataset.languages);
      this.updateLanguageOptions(languages, this.currentLanguageCode);
    }

    _parseLanguages(str) {
      if (!str) return [];

      const cleaned = str.endsWith('|') ? str.slice(0, -1) : str;
      if (!cleaned) return [];

      return cleaned
        .split('|')
        .map((pair) => {
          const [code, name] = pair.split(',').map((s) => s.trim());
          return code && name ? { iso_code: code, endonym_name: name } : null;
        })
        .filter(Boolean);
    }

    onCountryChange() {
      const option = this.countrySelect.selectedOptions[0];
      if (!option) return;

      const countryCode = option.value;
      this.updateCountryFlagVisuals(countryCode);

      const languages = this._parseLanguages(option.dataset.languages);
      if (!languages.length) return;

      let targetLanguage = null;
      const previousLanguage = this.languageSelect.value;

      if (previousLanguage) {
        const isAvailable = languages.some((lang) => lang.iso_code === previousLanguage);
        if (isAvailable) {
          targetLanguage = previousLanguage;
        }
      }

      this.updateLanguageOptions(languages, targetLanguage || languages[0].iso_code);
    }

    updateCountryFlagVisuals(countryCode) {
      if (!countryCode) return;

      const countryIso = countryCode.toLowerCase();
      this.countryFlags.forEach((flag) => flag.classList.add('hidden'));

      const selectedFlag = this.querySelector(`[data-country-flag="${countryIso}"]`);
      if (selectedFlag) selectedFlag.classList.remove('hidden');
    }

    updateLanguageOptions(languages, activeCode) {
      if (!languages.length) return;

      this.languageSelect.innerHTML = '';

      languages.forEach((lang) => {
        const option = document.createElement('option');
        option.value = lang.iso_code;
        option.textContent = lang.endonym_name;
        option.selected = lang.iso_code === activeCode;
        this.languageSelect.appendChild(option);
      });

      if (this.languageSelect.selectedIndex === -1 && this.languageSelect.options.length) {
        this.languageSelect.options[0].selected = true;
      }
    }
  }

  window.LanguageSwitcher = LanguageSwitcher;
  customElements.define('language-switcher', LanguageSwitcher);
}
